const prefix = "AbSplitTestForBlock_"; // Our A/B component prefix
const form = document.querySelector(".j-submit-cart");

function getCookiesWithPrefix(prefix) {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.startsWith(prefix))
    .map((cookie) => {
      const parts = cookie.split("=");
      return { name: parts[0], value: parts[1] };
    });
}

const matchingCookies = getCookiesWithPrefix(prefix);

const cookiesObject = {};
matchingCookies.forEach((cookie) => {
  cookiesObject[cookie.name] = cookie.value;
});

function objectToQueryString(obj) {
  return Object.entries(obj)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");
}

const urlParams = objectToQueryString(cookiesObject);

form.action = `/cart?step=contact_information${
  urlParams ? `&${urlParams}` : ""
}`;
